import { GetStaticProps } from 'next';
import React from 'react';
import { ContentApi } from '@model/iceberg';
import { PageTemplates } from '@model/content';
import { TripTypes } from '@model/common';
import { Revalidate } from '@model/config/revalidate';
import { TravelGuidePageLayout, TravelGuidePageLayoutProps } from '@layout/TraveGuidePageLayout/TravelGuidePageLayout';
import { getServerSidePropsTravelGuide } from '@layout/get-page-props';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { DestinationLevel, getTravelGuideStaticPaths } from '@util/get-destination-static-paths';

const TravelGuideCountryPage = (props: TravelGuidePageLayoutProps) => {
  return <TravelGuidePageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ req, params }: any) => ({
  ...(await getServerSidePropsTravelGuide({ store, req, query: params, tripType: TripTypes.ALL })),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const pageConfigMap = await new ContentApi().getPageConfigMap({ template: PageTemplates.TRAVEL_GUIDE_PAGE });

  const paths = getTravelGuideStaticPaths(pageConfigMap, DestinationLevel.COUNTRY, TripTypes.ALL);

  return { paths, fallback: false };
}

export default withGlobalProvider(TravelGuideCountryPage);
